import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/delete.svg'
import _imports_1 from '@/assets/icons/deletedisabledwarning.svg'
import _imports_2 from '@/assets/icons/user.svg'


const _hoisted_1 = { class: "userviewopts mr-5" }
const _hoisted_2 = { class: "divwithdelete" }
const _hoisted_3 = { class: "deletediv" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"40px"},
  alt: "delete user",
  title: "Delete User"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {"width":"40px"},
  alt: "deletedisabledimage",
  title: "Delete User"
}, null, -1)
const _hoisted_6 = { class: "userdivstyl" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  style: {"width":"80px","margin-right":"20px"},
  alt: "user image"
}, null, -1)
const _hoisted_8 = { class: "font-bold-24 breaking-words" }
const _hoisted_9 = { style: {"display":"flex","flex-direction":"column"} }
const _hoisted_10 = { class: "font-regular-18 breaking-words" }
const _hoisted_11 = { class: "font-regular-18" }
const _hoisted_12 = { class: "text-div font-regular-16" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "font-regular-16" }, "All user data and licenses will be permanently removed.", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "This action may not be undone.", -1)
const _hoisted_16 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            (_ctx.canDelete)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  plain: "",
                  class: "delbtn",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showDeleteDailogue = true)),
                  id: "deleteuser",
                  "data-cy": "delete-user-button"
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (!_ctx.canDelete)
              ? (_openBlock(), _createBlock(_component_el_tooltip, {
                  key: 1,
                  class: "box-item",
                  effect: "dark",
                  placement: "top"
                }, {
                  content: _withCtx(() => [
                    _createTextVNode(" User can not be deleted due to borrowed licences. ")
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      plain: "",
                      class: "delbtn",
                      id: "deleteWarning",
                      "data-cy": "delete-user-warn-button"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", null, [
            _createElementVNode("h2", _hoisted_8, _toDisplayString(_ctx.userData.firstName) + " " + _toDisplayString(_ctx.userData.lastName), 1),
            _createVNode(_component_el_button, {
              class: "flowstyle breaking-words",
              id: "viewUserDetails",
              type: "warning",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.viewDetails(_ctx.userData))),
              link: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.userData.companyName), 1)
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.userData.email), 1),
              _createElementVNode("label", _hoisted_11, " Status: " + _toDisplayString(_ctx.userData.userStatus), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      title: "Delete Users",
      modelValue: _ctx.showDeleteDailogue,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showDeleteDailogue) = $event)),
      width: "35%",
      top: "25vh",
      center: ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_16, [
          _createVNode(_component_el_button, {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showDeleteDailogue = false)),
            round: "",
            class: "cancelbtn",
            variant: "outline-dark"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cancel")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "danger",
            onClick: _ctx.deleteUser,
            round: "",
            class: "deletebutton"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Confirm")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_divider),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("span", null, [
            _createTextVNode("Selected user "),
            _createElementVNode("strong", null, _toDisplayString(_ctx.userData.firstName) + " " + _toDisplayString(_ctx.userData.lastName), 1)
          ]),
          _hoisted_13,
          _hoisted_14,
          _hoisted_15
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}